module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/glasses.c6f473aa6ce85272.gif";